
import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsClient from './components/Settings/SettingsClient'
import SettingsStep from './components/Settings/SettingsStep'

import {
  setTitle
} from 'common/redux/root'

import {
  saveClientCategories, updateClientCategories
} from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsClientContainer extends Component {

  componentWillMount() {
    this.props.dispatch(setTitle("My Client Types"))
  }

  handleSubmit = cb => {
    const { dispatch, settings } = this.props
    if (this.isValid()) {
      dispatch(saveClientCategories(settings.client_categories)).then(cb)
    }
  }

  handleSelect = (key, enabled) => {
    this.props.dispatch(updateClientCategories(key, enabled))
  }

  isValid = () => {
    const { settings } = this.props
    return settings.client_categories && Object.keys(settings.client_categories).length !== 0
  }

  render() {
    return <SettingsStep shouldDisableSubmit={!this.isValid()} onSubmit={this.handleSubmit} {...this.props}>
      <SettingsClient onSelect={this.handleSelect} {...this.props} />
    </SettingsStep>
  }

}

export default connect((state) => ({ settings: state.settings }), mapDispatchToProps)(SettingsClientContainer)
